import { render, staticRenderFns } from "./boxVente.vue?vue&type=template&id=68c26334&"
import script from "./boxVente.vue?vue&type=script&lang=js&"
export * from "./boxVente.vue?vue&type=script&lang=js&"
import style0 from "./boxVente.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports